<ycn-page-toast-messages></ycn-page-toast-messages>

<div class="page-header page-header-support">
    <div class="container">
        <div class="w-full max-width-lg ml-auto mr-auto">
            <div class="row">
                <div class="page-title col-auto">
                    <h1 class="page-name">Financial Glossary</h1>
                </div>
                <div class="page-header-actions">
                    <div class="width-260">
                        <ycn-icon-search-autocomplete
                            [appendToBody]="false"
                            [placeholder]="'Search Term'"
                            [searchType]="'glossary_term'"
                            (submitHandler)="navigateToDefinitionPage($event.search_id)">
                        </ycn-icon-search-autocomplete>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<section class="page-body container">
    <div class="max-width-lg width-full ml-auto mr-auto">
        <div class="row wide-gutters-lg">
            @if(categories.length > 0) {
                <section class="col-3 tabs tabs-vertical">
                    <div class="tabs tabs-vertical">
                        <ul class="nav nav-sticky">
                            @for(category of categories; track category.internalName) {
                                <li class="nav-item">
                                    <a href="javascript:void(0)"
                                    class="nav-link"
                                    [ngClass]="{'active': selectedCategory === category.internalName || selectedParentCategory === category.internalName}"
                                    (click)="filterByCategory(category.internalName)">
                                        {{ category.name }}
                                    </a>
                                    @if(category.subcategories) {
                                        <ul class="list-unstyled ml-1" style="display: block;">
                                        @for(subcategory of category.subcategories; track subcategory.internalName) {
                                            <li><a href="javascript:void(0)"
                                            class="nav-link"
                                            [ngClass]="{'active': selectedCategory === subcategory.internalName}"
                                            (click)="filterByCategory(subcategory.internalName, category.internalName)">
                                                {{ subcategory.name }}
                                            </a></li>
                                        }
                                        </ul>
                                    }
                                </li>
                            }
                        </ul>
                    </div>
                </section>
            }
            <section class="tab-content" [ngClass]="{'col-12': categories.length === 0, 'col-9': categories.length > 0}">
                <div class="tab-pane active pl-0 pr-0">
                    <!-- Alphabetic table of contents -->
                    <div class="d-flex align-items-center justify-evenly flex-wrap mb-4" style="justify-content: space-evenly;">
                        @for (letter of alphabet; track letter) {
                            @if(letters.indexOf(letter) > -1) {
                                <a href="javascript:void(0)"
                                (click)="scrollToLetter(letter)"
                                class="btn btn-link">
                                    {{ letter }}
                                </a>
                            } @else {
                                <span class="btn btn-link disabled"
                                style="cursor: default;">
                                    {{ letter }}
                                </span>
                            }
                        }
                    </div>
                    <!-- Glossary terms -->
                    @for (letter of letters; track letter) {
                        <section class="mb-5" id="section-{{ letter }}">
                            <div class="topic-title mb-2">{{ letter }}</div>
                            <hr class="hr mb-3">
                                <ul class="list-unstyled glossary-section-terms" style="list-style: none; padding-left: 0; margin-left: 0; column-count: 3; column-gap: 2rem;">
                                    @for (term of terms[letter]; track term.internalName) {
                                        <li class="mb-1 block">
                                            <a href="javascript:void(0)"
                                            class="text-link"
                                            (click)="navigateToDefinitionPage(term.internalName)">
                                                {{ term.name }}
                                                @if(term.videoLink) {
                                                    <span class="ml-1 btn btn-circle btn-sm btn-transparent">
                                                        <svg ycnIcon [name]="'icon-video'"></svg>
                                                    </span>
                                                }
                                            </a>
                                        </li>
                                    }
                                </ul>
                        </section>
                    }
                </div>
            </section>
        </div>
    </div>
</section>